interface ISimpleFlatBlock {
  depth: number;
  allowChildren: boolean;
}

export function getMaxDepth<IFlatBlock extends ISimpleFlatBlock>(items: IFlatBlock[], to: number): number {
  const previousItem = items[to - 1];
  if (!previousItem) {
    return 0;
  }
  if (!previousItem.allowChildren) {
    return previousItem.depth;
  }
  return previousItem.depth + 1;
}

export function getMinDepth<IFlatBlock extends ISimpleFlatBlock>(items: IFlatBlock[], to: number): number {
  const nextItem = items[to];
  return nextItem ? nextItem.depth : 0;
}
